<template>
    <fieldset :disabled="formDisabled">
        <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="prehistoricArtifact">
            <div class="form-group">
                <label class="col-md-2 control-label">Component Age(s)</label>
                <!--<div class="col-md-10">
                    <checkBoxPanel :numColumns="3" :lookupList="significantPeriodList" ref="periodCheckboxPanel" :fieldName="'significantPeriodId'" name="prehistoricArtifactSigPeriodCB" />
                </div>-->
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'significantPeriodList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <ageSelection :isPrehistoric="true" :parentFormName="qaqcFieldId + 'paf'" ref="ageSelection"></ageSelection>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Artifacts</label>
                <div class="col-md-4">
                    <div class="well">
                        <div class="form-inline">
                            <label>General</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'hasTimeDiagnostics'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li>
                                <div class="checkbox checkbox-inline">
                                <input :id="qaqcFieldId + 'timeDiagnosticCB'" type="checkbox" v-model="assemblageDto.hasTimeDiagnostics">
                                    <label :for="qaqcFieldId + 'timeDiagnosticCB'">Time Diagnostic</label>
                                </input>
                                </div>
                                <div class="checkbox checkbox-inline">
                                <input :id="qaqcFieldId + 'affiliationDiagnosticCB'" type="checkbox" v-model="assemblageDto.hasAffiliationDiagnostics">
                                    <label :for="qaqcFieldId + 'affiliationDiagnosticCB'">Affiliation Diagnostics</label>
                                </input>
                                </div>
                            </li>
                        </ul>
                        <div class="form-inline">
                            <label>Chipped Stone</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList1'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 1 && x.artifactId !== 2})" :key="artifact.artifactId">
                              <form class="form-inline inline-container">
                                  <div class="checkbox checkbox-inline">
                                    <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.artifactId + artifact.description" :value="artifact.artifactId" />
                                    <label :for="qaqcFieldId + artifact.artifactId + artifact.description">{{artifact.description}}</label>
                                  </div>
                                <input class="form-control inline-input" type="number" min="0" style="width:60px" placeholder="count"
                                    v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)" v-model="countList[artifact.artifactId]" />
                              </form>
                            </li>
                            <li>
                                <form class="form-inline inline-container">
                                    <div class="checkbox checkbox-inline">
                                        <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + 'Debitage'" :value="2" />
                                        <label :for="qaqcFieldId + 'Debitage'">Debitage</label>
                                    </div>
                                </form>
                                <div v-show="selectedList.includes(2)">
                                    <div class="form-inline">
                                        <label>Debitage Frequency</label>
                                        <select class="form-control" v-model="assemblageDto.debitageFrequencyId" name="debitageFrequency">
                                            <option :value="null">Select a value</option>
                                            <option :value="6">Unknown</option>
                                            <option :value="6">None</option>
                                            <option :value="1">10 or less</option>
                                            <option :value="2">11-100</option>
                                            <option :value="3">101-1000</option>
                                            <option :value="4">1001-10000</option>
                                            <option :value="5">>10000</option>
                                        </select>
                                    </div>
                                    <div class="form-inline" style="margin-top: 20px;">
                                        <label>Debitage Composition</label>
                                    </div>
                                    <div class="form-inline">
                                        <input class="form-control inline-input" type="number" min="0" step=".1" style="margin-top: 0px; max-width: 70px;"
                                            v-model="assemblageDto.debitageCompositionPrimary" />
                                        <label class="label-control">% Primary</label>
                                    </div>
                                    <div class="form-inline">
                                        <input class="form-control inline-input" type="number" min="0" step=".1" style="margin-top: 0px; max-width: 70px;"
                                            v-model="assemblageDto.debitageCompositionSecondary" />
                                        <label class="label-control">% Secondary</label>
                                    </div>
                                    <div class="form-inline">
                                        <input class="form-control inline-input" type="number" min="0" step=".1" style="margin-top: 0px; max-width: 70px;"
                                            v-model="assemblageDto.debitageCompositionTertiary" />
                                        <label class="label-control">% Tertiary</label>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!-- <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + 'obsidianCB'" :value="11">
                            <label :for="qaqcFieldId + 'obsidianCB'">Obsidian</label>
                        </div>
                        <br />
                        <label>Fire-Altered Rock Debitage Frequency</label>
                        <div class="form-inline">
                            <select class="form-control" style="width:125px">
                                <option value="">Select a value</option>
                                <option value="1">10 or less</option>
                                <option value="2">11-100</option>
                                <option value="3">101-1000</option>
                                <option value="4">1001-10000</option>
                                <option value="5">>10000</option>
                                <option value="6">Unknown</option>
                            </select>
                        </div> -->

                    </div>
                    <div class="well">
                        <div class="form-inline">
                            <label>Ground Stone</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList2'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 2})" :key="artifact.artifactId">
                                <form class="form-inline inline-container">
                                    <div class="checkbox checkbox-inline">
                                        <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.description" :value="artifact.artifactId" />
                                        <label :for="qaqcFieldId + artifact.description">{{artifact.description}}</label>
                                    </div>
                                    <input class="form-control inline-input" type="number" min="0" style="width:60px" placeholder="count"
                                        v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                                        v-model="countList[artifact.artifactId]" />
                                </form>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="well">
                        <div class="form-inline">
                            <label>Bone and Organic</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList4'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 4})">
                                <div class="checkbox checkbox-inline">
                                    <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.description" :value="artifact.artifactId">
                                        <label :for="qaqcFieldId + artifact.description">{{artifact.description}}</label>
                                    </input>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="well">
                        <div class="form-inline">
                            <label>Ceramics / Steatite</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList3'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId ===3})">
                                <form class="form-inline inline-container">
                                    <div class="checkbox checkbox-inline">
                                        <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.description" :value="artifact.artifactId">
                                            <label :for="qaqcFieldId + artifact.description">{{artifact.description}}</label>
                                        </input>
                                    </div>
                                    <input class="form-control inline-input" type="number" min="0" style="width:60px" placeholder="count"
                                        v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                                        v-model="countList[artifact.artifactId]"></input>
                                </form>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="well">
                        <div class="form-inline">
                            <label>Other Artifacts</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList5'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 5})">
                                <form class="form-inline inline-container">
                                    <div class="checkbox checkbox-inline">
                                        <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.description" :value="artifact.artifactId">
                                            <label :for="qaqcFieldId + artifact.description">{{artifact.description}}</label>
                                        </input>
                                    </div>
                                    <input class="form-control inline-input" type="number" min="0" style="width:60px" placeholder="count"
                                        v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                                        v-model="countList[artifact.artifactId]"></input>
                                </form>
                            </li>
                        </ul>
                    </div>
                    <div class="well">
                        <div class="form-inline">
                            <label>Human Remains</label>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageDetailsList6'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        <ul type="none" style="padding-left:0px">
                            <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 6})">
                                <div class="checkbox checkbox-inline">
                                    <input type="checkbox" v-model="selectedList" :id="qaqcFieldId + artifact.description" :value="artifact.artifactId">
                                        <label :for="qaqcFieldId + artifact.description">{{artifact.description}}</label>
                                    </input>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Estimated Total Assemblage Size</label>
                <div class="col-md-3 form-inline">
                   <select class="form-control" v-model="assemblageDto.assemblageSizeId" v-validate="'required'" name="assemblageSize">
                        <option value="">Select a value</option>
                        <option value="1">10 or less</option>
                        <option value="2">11-100</option>
                        <option value="3">101-1000</option>
                        <option value="4">1001-10000</option>
                        <option value="5">>10000</option>
                        <option value="6">Unknown</option>
                    </select>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'assemblageSizeId'" :hasAppend="false"></qaqcFormFieldSelect>
                    <span v-show="errors.has('prehistoricArtifact.assemblageSize')" class="has-error">{{ errors.first('prehistoricArtifact.assemblageSize') }}</span>
                </div>
                <label class="col-md-2  col-md-2-offset control-label">Keywords</label>
                <div class="col-md-4 form-inline">
                    <input type="text" class="form-control" v-model="assemblageDto.keywords">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'keywords'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2">Diagnostic Artifact Inventory</label>
                <div class="col-md-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'prehistoricInventoryList'" :hasAppend="true"></qaqcFormFieldSelect>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>General Age</th>
                                <th>Type Name</th>
                                <th>Materials</th>
                                <th>Collected</th>
                                <th>Technological / Cultural Complex</th>
                                <th>Description</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in inventoryList">
                                <td>{{item.significantPeriodDescription}}</td>
                                <td>{{item.artifactDescription}}</td>
                                <td>{{item.materials}}</td>
                                <td>{{item.collected}}</td>
                                <td>{{item.techCultureDescription}}</td>
                                <td>{{item.description}}</td>
                                <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeInventory(index)"></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div  v-if="!formDisabled" class="form-group">
                <div class="col-md-1 col-md-offset-10">
                    <button class="form-contol btn" v-on:click="$refs['inventoryModal'].open()">Add Inventory</button>
                </div>
            </div>
            <modal ref="inventoryModal">
                <div slot="header" class="row">
                    <h3 class="pull-left">Artifact Inventory Entry</h3>
                    <button class="btn pull-right" v-on:click="$refs['inventoryModal'].close()">X</button>
                </div>
                <div slot="body">
                    <div class="form form-horizontal">
                        <div class="row">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('inventoryModalBox.significantPeriod') }">
                                <label class="col-md-4 control-label">General Age</label>
                                <div class="col-md-8">
                                    <select class="form-control" v-model="inventoryDto.significantPeriodId" v-validate="'required'" name="significantPeriod" data-vv-scope="inventoryModalBox">
                                        <option value="">Select a value</option>
                                        <!-- TODO: filter this to what is selected above -->
                                        <option v-for="period in significantPeriodList" :value="period.prehistoricAgeId">
                                            {{ period.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('inventoryModalBox.significantPeriod')" class="has-error">{{ errors.first('inventoryModalBox.significantPeriod') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('inventoryModalBox.typeName') }">
                                <label class="col-md-4 control-label">Type Name</label>
                                <div class="col-md-8">
                                    <select class="form-control" v-model="inventoryDto.artifactTypeId" v-validate="'required'" name="typeName" data-vv-scope="inventoryModalBox">
                                        <option value="">Select a value</option>
                                        <option v-for="artifactType in artifactTypeList" :value="artifactType.artifactTypeId">
                                            {{artifactType.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('inventoryModalBox.typeName')" class="has-error">{{ errors.first('inventoryModalBox.typeName') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Materials (if known)</label>
                                <div class="col-md-8">
                                    <input class="form-control" type="text" v-model="inventoryDto.materials"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Collected</label>
                                <div class="col-md-8">
                                    <div class="checkbox checkbox-inline">
                                        <input type="checkbox" :id="qaqcFieldId + 'collectedCheckbox'" v-model="inventoryDto.collected">
                                            <label :for="qaqcFieldId + 'collectedCheckbox'">&nbsp;</label>
                                        </input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('inventoryModalBox.techCulture') }">
                                <label class="col-md-4 control-label">Technological or Cultural Complex</label>
                                <div class="col-md-8">
                                    <select class="form-control" v-model="inventoryDto.techCultureId" v-validate="'required'" name="techCulture" data-vv-scope="inventoryModalBox">
                                        <option value="">Select a value</option>
                                        <option v-for="tech in techCultureList" :value="tech.techCultureId">
                                            {{tech.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('inventoryModalBox.techCulture')" class="has-error">{{ errors.first('inventoryModalBox.techCulture') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Description</label>
                                <div class="col-md-8">
                                    <input class="form-control" type="text" v-model="inventoryDto.description" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div slot="footer">
                        <div class="row">
                            <button name="buttonDone" class="btn btn-primary col-md-3" v-on:click="inventoryDone()">Done</button>
                            <button name="buttonMore" class="btn btn-primary col-md-3 pull-right" v-on:click="inventoryMore()">More</button>
                        </div>
                    </div>
            </modal>
            <div v-if="!(formDisabled || qaqcEnabled)" class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="savePrehistoricArtifact">Save</button>
            </div>
            <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'prehistoricArtifact'" :completeSection="completeSection"></qaqcFormFieldFooter>
        </form>
    </fieldset>
</template>

<script>
import checkBoxPanel from '../CheckBoxPanel.vue'
import modal from '../Modal.vue'
import loggingService from '../../services/util/loggingService'
import artifactService from '../../services/lookup/artifactService'
import significantPeriodService from '@/services/siteForm/significantPeriodService'
import prehistoricArtifactService from '../../services/siteForm/prehistoricArtifactService'
import ageSelection from './ageSelection'
// import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'prehistoricArtifactForm',
    components: {
        checkBoxPanel,
        modal,
        ageSelection,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            significantPeriodList: significantPeriodService.getPrehistoricAgeList(),
            artifactTypeList: prehistoricArtifactService.getArtifactTypeList(),
            techCultureList: prehistoricArtifactService.getTechCultureList(),
            artifactList: [],
            selectedList: [],
            countList: [],
            inventoryList: [],
            inventoryDto: {},
            assemblageDto: {}
        }
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no propertyDescription qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.prehistoricArtifact) {
                //     this.qaqcProgressDto.qaqcSelections.prehistoricArtifact = qaqcService.qaqcSelections().prehistoricArtifact
                // }
                return this.qaqcProgressDto.qaqcSelections.prehistoricArtifact
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Prehistoric Artifact Form', message)
        },
        loadData () {
            var crrId = this.crrId
            this.log('Searching for assemblage for crr: ' + crrId)
            return prehistoricArtifactService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                if (result.data.length > 0) {
                    this.assemblageDto = result.data[0]
                    this.selectedList = this.assemblageDto.assemblageDetailsList.map(x => {
                        return x.artifactId
                    })
                    // populate the count
                    this.assemblageDto.assemblageDetailsList.forEach(item => {
                        this.countList[item.artifactId] = item.artifactCount
                    })
                    this.log('Found one assemblage: ' + this.assemblageDto.keywords)
                    this.$refs.ageSelection.setSelection(this.assemblageDto.significantPeriodList)
                    // load inventory items
                    this.inventoryList = []
                    this.assemblageDto.prehistoricInventoryList.forEach(item => {
                        this.createInventoryDto()
                        this.inventoryDto = item
                        this.encodeInventory(this.inventoryDto)
                        this.inventoryList.push(this.inventoryDto)
                    })
                    this.createInventoryDto()
                } else {
                    this.assemblageDto.culturalResourceRecordingId = crrId
                    this.createInventoryDto()
                    this.log('Nothing found')
                }
                return result
            })
        },
        loadLookups () {
            artifactService.listArtifact(this.$http).then(result => {
                this.artifactList = result.data
            })
        },
        createInventoryDto () {
            this.inventoryDto = {
                significantPeriodId: '',
                significantPeriodDescription: '',
                artifactTypeId: '',
                artifactDescription: '',
                materials: '',
                count: 0,
                collected: false,
                techCultureId: '',
                techCultureDescription: '',
                description: ''
            }
        },
        encodeInventory (inventoryItem) {
            inventoryItem.significantPeriodDescription = this.significantPeriodList.find(x => { return inventoryItem.significantPeriodId === x.prehistoricAgeId }).description
            inventoryItem.artifactDescription = this.artifactTypeList.find(x => { return inventoryItem.artifactTypeId === x.artifactTypeId }).description
            inventoryItem.techCultureDescription = this.techCultureList.find(x => { return inventoryItem.techCultureId === x.techCultureId }).description
        },
        inventoryDone () {
            this.$validator.validateAll('inventoryModalBox').then(x => {
                this.encodeInventory(this.inventoryDto)
                this.inventoryList.push(this.inventoryDto)
                this.createInventoryDto()
                this.$refs.inventoryModal.close()
            })
        },
        inventoryMore () {
            this.$validator.validateAll('inventoryModalBox').then(x => {
                this.encodeInventory(this.inventoryDto)
                this.inventoryList.push(this.inventoryDto)
                this.createInventoryDto()
            })
        },
        savePrehistoricArtifact () {
            this.$validator.validateAll('prehistoricArtifact').then(x => {
                this.log('validation complete')
                this.assemblageDto.assemblageDetailsList = this.selectedList.map(x => {
                    return {
                        parentId: this.assemblageDto.prehistoricArtifactAssemblageId || 0,
                        assemblageTypeId: 1,
                        artifactId: x,
                        artifactCount: this.countList[x]
                    }
                })
                this.assemblageDto.prehistoricInventoryList = this.inventoryList.map(x => {
                    x.prehistoricArtifactAssemblageId = this.assemblageDto.prehistoricArtifactAssemblageId || 0
                    return x
                })
                var ageList = this.$refs.ageSelection.ageList.filter(x => { return x.isSelected })
                this.assemblageDto.significantPeriodList = ageList.map(x => {
                    x.significantPeriodId = x.selectId
                    x.prehistoricArtifactAssemblageId = this.assemblageDto.prehistoricArtifactAssemblageId || 0
                    return x
                })

                this.assemblageDto.significantPeriodList.forEach(x => {
                    this.log(`sig period id: ${x.prehistoricAgeId}, isSurface: ${x.isSurface},  isSubsurface: ${x.isSubsurface}, phase: ${x.prehistoricPhaseId}`)
                })

                prehistoricArtifactService.put(this.$http, this.assemblageDto).then(result => {
                    this.log('form saved')
                    this.loadData()
                })
            })
        },
        removeInventory (index) {
            this.inventoryList.splice(index, 1)
        },
        completeSection (sectionName) {
            // set consolidated selections
            this.qaqcSelection.hasAffiliationDiagnostics = this.qaqcSelection.hasTimeDiagnostics
            this.qaqcSelection.assemblageDetailsList11 = this.qaqcSelection.assemblageDetailsList1
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.savePrehistoricArtifact()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>

<style>
.inline-container {
  display: flex;
  flex-direction: row;
  /*justify-content: space-between;*/
}

.inline-input {
  display: flex;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// PrehistoricArtifactForm.vue?25b42d9a